import { useState } from 'react'

const brandColors: Record<string, string> = {
  'Hikvision': '#cc0000', 'Ubiquiti': '#2563eb', 'Dell': '#007db8',
  'Denon': '#1a1a2e', 'Sonance': '#2d5a27', 'JL Audio': '#8b0000',
  'Sony': '#000000', 'Wavelynx': '#1e3a5f', 'Orion Access': '#d4880f',
  'APC': '#ff6600', 'Monoprice': '#4b5563',
}

/** Construct a likely manufacturer image URL from brand + MPN */
export function getManufacturerImageUrl(manufacturer?: string | null, mpn?: string | null): string | null {
  if (!manufacturer || !mpn) return null
  const brand = manufacturer.toLowerCase().trim()
  const model = mpn.trim()
  if (!model) return null

  if (brand === 'hikvision') return `https://www.hikvision.com/content/dam/hikvision/products/${model}.png`
  if (brand === 'ubiquiti') return `https://images.svc.ui.com/?u=https://static.ui.com/fingerprint/ui/images/${model}.png&w=256`
  if (brand === 'apc') return `https://www.apc.com/media/catalog/product/${model}.png`
  return null
}

export function getBrandColor(brand?: string | null): string {
  if (!brand) return 'var(--color-infra)'
  return brandColors[brand] || `hsl(${brand.charCodeAt(0) * 7 % 360}, 45%, 45%)`
}

interface ProductImageProps {
  item: {
    image_r2_key?: string | null
    image_url?: string | null
    manufacturer?: string | null
    item_type?: string | null
    name?: string
  }
  size?: number
}

export function ProductImage({ item, size = 44 }: ProductImageProps) {
  const [imgError, setImgError] = useState(false)

  // Priority: R2 local copy > direct URL > brand placeholder
  const src = item.image_r2_key
    ? `/api/files/${item.image_r2_key}`
    : item.image_url && !imgError
      ? item.image_url
      : null

  if (!src) {
    const isLabor = item.item_type === 'labor'
    const bg = isLabor ? 'var(--color-infra)' : getBrandColor(item.manufacturer)
    const initials = isLabor ? 'LBR' : (item.manufacturer?.slice(0, 3) || '?')

    return (
      <div
        style={{
          width: size, height: size, borderRadius: 8, flexShrink: 0,
          background: `linear-gradient(135deg, ${bg}dd, ${bg})`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontSize: Math.max(9, size / 5), fontWeight: 700,
          textTransform: 'uppercase', letterSpacing: '.03em',
        }}
      >
        {initials}
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={item.name || ''}
      onError={() => setImgError(true)}
      style={{
        width: size, height: size, borderRadius: 8,
        objectFit: 'cover', flexShrink: 0,
      }}
    />
  )
}
